import { CSSProperties } from 'react';

export enum PlatformPageSectionType {
  TEXT_GRID = 'TEXT_GRID',
  TEXT_IMAGE = 'TEXT_IMAGE',
  TEXT_CALENDAR = 'TEXT_CALENDAR',
  IMAGE_FORM = 'IMAGE_FORM',
  FULL_IMAGE = 'FULL_IMAGE',
  IMAGE_2x2_GRID = 'IMAGE_2x2_GRID',
  CALL_TO_ACTION = 'CALL_TO_ACTION',
  INSTRUCTIONAL_VIDEOS = 'INSTRUCTIONAL_VIDEOS',
  PRICING = 'PRICING',
  CUSTOMER_REVIEWS = 'CUSTOMER_REVIEWS',
  EMPTY = 'EMPTY',
}

export enum PlatformPageType {
  AFFILIATE_MARKETING = 'AFFILIATE_MARKETING',
  ANALYTICS = 'ANALYTICS',
  BUSINESS_KIT = 'BUSINESS_KIT',
  DESIGN_STUDIO = 'DESIGN_STUDIO',
  IDEATION_AND_BRAND_SETUP = 'IDEATION_AND_BRAND_SETUP',
  LOGISTICS_AND_FULFILLMENT = 'LOGISTICS_AND_FULFILLMENT',
  PIETRA_AI = 'PIETRA_AI',
  PRINT_ON_DEMAND = 'PRINT_ON_DEMAND',
  PRIVATE_WHOLESALE = 'PRIVATE_WHOLESALE',
  RETURNS = 'RETURNS',
  SALES_AND_MARKETING = 'SALES_AND_MARKETING',
  SOURCING_AND_PRODUCTION = 'SOURCING_AND_PRODUCTION',
  RETAIL_CONNECT = 'RETAIL_CONNECT',
  SOCIAL_ANALYSIS = 'SOCIAL_ANALYSIS',
  CONTENT_STUDIO = 'CONTENT_STUDIO',
}

export interface PlatformPageHero {
  colors: {
    text: string;
    background?: string;
  };
  bgImage?: string;
  bgImageAltText?: string;
  secondaryImage?: string;
  tertiaryImage?: string;
  btnText: string;
  btnHubUrl?: string;
  btnScrollTo?: string;
  secondaryBtn?: {
    text: string;
    creatorHubUrl?: string;
    externalUrl?: string;
  };
  description: string;
  platformIcon?: string;
  class: string;
  isHeroOverlayShown?: boolean;
  showVideo?: boolean;
  showSignUp: boolean;
  heroVideo?: string;
}

export interface PlatformPageTextGridItem {
  icon: string;
  title: string;
  description: string;
}

export interface PlatformPagePricingGridItemFeature {
  icon: string;
  text: string;
}
export interface PlatformPagePricingGridItem {
  preTitle: string;
  title: string;
  button: PlatformPageSectionButton;
  features: PlatformPagePricingGridItemFeature[];
}
export interface PlatformPageReviewItem {
  text: string;
  stars: number;
  avatar: string;
  name: string;
  org: string;
}

export interface PlatformInstructionalVideo {
  videoUrl: string;
  thumbnail: string;
  altText: string;
}

export interface PlatformPageFullGridImage {
  imgSrc: string;
  imgAlt: string;
  title: string;
  description: string;
}

export interface PlatformPageSectionButton {
  btnText: string;
  btnHubUrl?: string;
  btnClass?: string;
  onClick?: (router?: any) => void;
}

export interface IPlatformPageSection {
  type: PlatformPageSectionType;
  bgColor?: string;
  background?: string;
  preTitle?: string;
  preTitleColor?: string;
  title?: string;
  titleColor?: string;
  description?: string;
  calendlyUrl?: string;
  descriptionColor?: string;
  buttons?: PlatformPageSectionButton[];
  image?: string;
  imageTitle?: string;
  imageStyle?: CSSProperties;
  fullGridImages?: PlatformPageFullGridImage[];
  textGridItems?: PlatformPageTextGridItem[];
  pricingItems?: PlatformPagePricingGridItem[];
  reviewItems?: PlatformPageReviewItem[];
  isComingSoon?: boolean;
  instructionalVideos?: PlatformInstructionalVideo[];
  sendEmailToCreator?: (email: string) => {};
  id?: string;
  discountText?: string;
}

export interface IPlatformPage {
  type: PlatformPageType;
  title: string;
  hero?: PlatformPageHero;
  brandLogos?: boolean;
  textWithHighlight?: boolean;
  sections: IPlatformPageSection[];
}

interface ICaption {
  content: string;
  style?: CSSProperties;
}

export type IPlatformHeaderContent = Partial<{
  platformName: string;
  heroImage: { url: string; width: number; height: number; mobileWidth: number; mobileHeight: number };
  title?: string;
  description: string;
  titleClass?: string;
  descriptionClass?: string;
  color: string;
  backgroundColor: string;
  bookDemoPath?: string;
  btnText?: string;
  compareToLogos?: { url: string; width: number; height: number }[];
  popularUseCases?: {
    title: { text: string; color: string };
    cards: IModuleStarterCard[];
  };
  comparison?: {
    pricing: string;
    limits: string;
    competitorPricing?: ICaption;
    competitorLimits?: ICaption;
    memberPricingStyle?: CSSProperties;
  };
  companyLogos?: {
    title: string;
    logos: { name: string; url: string; width: number; height: number }[];
  };
  sendEmailToCreator: (email: string) => {};
  showAccessHeader: boolean;
  heroTitle?: string;
  heroBanner?: Array<{
    title: string;
    description: string;
    remark?: string;
    imageUrl: string;
  }>;
}>;

export interface MonthlyOrderCosts {
  orderPickFee: number;
  additionalItemPickFee: number;
  promotionalInserts: number;
  returnProcessing: string;
}

export interface OrderSavingsComparisonMap {
  competitor: MonthlyOrderCosts;
  pietra: MonthlyOrderCosts;
}

export interface IModuleStarterCard {
  pill: string;
  icon: string;
  title: string;
  desc: string;
  color: string;
  button: {
    text: string;
    color: string;
    bgColor: string;
    onClick: (router?: any) => void;
  };
}
